"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlertCaveats = exports.filterCaveats = void 0;
var _reject2 = _interopRequireDefault(require("lodash/reject"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var alertCaveatCodes = ['MULTIPLE_CARRIERS_IN_RECOMMENDATION', 'PRODUCT_CONFIG_MISSING_FULFILLMENT_CONFIGURATIONS', 'FULFILLMENT_LOCATION_NOT_FOUND'];
var ignoredCaveatCodes = ['MCP_STANDARD_SHIPPABLE_PACK_ATTRIBUTE_NOT_FOUND', 'SHIPPING_ATTRIBUTE_NOT_FOUND', 'PACK_COLLECTION_NOT_FOUND_IN_PRODUCT_CONFIG'];
var getAlertCaveats = exports.getAlertCaveats = function getAlertCaveats(caveats) {
  if (!caveats) {
    return [];
  }
  return (0, _uniqBy2["default"])((0, _filter2["default"])(caveats, function (caveat) {
    return alertCaveatCodes.includes(caveat.code);
  }), 'code');
};
var filterCaveats = exports.filterCaveats = function filterCaveats(caveats) {
  if (!caveats) {
    return [];
  }
  return (0, _reject2["default"])(caveats, function (caveat) {
    return ignoredCaveatCodes.includes(caveat.code);
  });
};